import { Box } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import axios from 'axios';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';

import PageHeader from '../helper/PageHeader';
import SimpleTable from '../helper/SimpleTable';
import styles from '../styles';
import Loading from '../helper/Loading';
import { authContext } from "../../context/AuthContext";
import { SearchBarFirstLastRequired } from '../helper/SearchBars';


const tableCells = [
    { id: 'username', label: 'Username', centered: false },
    { id: 'name', label: 'Name', centered: false },
    { id: 'email', label: 'Email', centered: false },
    { id: 'isInstructor', label: 'Instructor', centered: false },
];

const AdminInstrucAdd = props => {
    const { classes } = props
    const history = useHistory()
    const user = useContext(authContext)

    const [data, setData] = useState(null)
    const [originalLength, setOriginalLength] = useState(-1) // to display the truncation amount
    const [loading, setLoading] = useState(false)
    const mounted = useRef(true)

    useEffect(() => {
        // on unmount
        return () => mounted.current = false
    }, [])

    const onSearch = async (search) => {
        console.log(user)
        setLoading(true)
        const res = await axios.get('/api/instructor/searchUser', {
            headers: {
                Authorization: user.accessToken
            },

            params: {
                firstName: search.firstName === '' ? null : search.firstName,
                lastName: search.lastName === '' ? null : search.lastName,
            }
        })
        if (mounted.current) {
            // grab the first 100
            // console.log(res.data)
           // console.log(res.data.user)
            const data = res.data.user.slice(0, 100).map(user => ({
                username: user.username,
                name: user.last_name + ', ' + user.first_name,
                first_name: user.first_name,
                last_name: user.last_name,
                middle_name: user.middle_name,
                suffix: user.suffix,
                email: user.email,
                isInstructor: user.isInstructor === 0 ? "No" : "Yes",
                actionsDisabled: {
                    add: user.isInstructor === 1,
                }
            }))

            setOriginalLength(res.data.user.length)
            setData(data)
            setLoading(false)
        }

    }

    const onAdd = username => {
        let user = data.find(e => e.username === username);
        history.push("/administration/instructor", {
            username: username,
            user: user
        })
    }


    const actionButtons = [
        { icon: "add", action: onAdd, delete: false },
    ];

    return (
        <>
            <PageHeader
                title={"Search Users to Add as Instructor"}
                cancel={history.goBack}
            />
            <SearchBarFirstLastRequired classes={classes} onSearch={onSearch} />
            
            <br /><br />

            {loading ? <Loading /> : // if loading display message
                data === null ?
                    null : // if there is no data display nothing
                    data.length === 0 // if there is data but it is empty
                        ?
                        <Box display="flex" mt={4} justifyContent="center">
                            <h1>No Data</h1>
                        </Box>
                        :
                        <>
                            {originalLength > 100 && <p>{`Found too many results (${originalLength}) limiting results to 100`}</p>}
                            <SimpleTable
                                data={data}
                                cellKey={"username"}
                                tableCells={tableCells}
                                actionButtons={actionButtons}
                                actions={true}
                            />
                        </>
            }
        </>
    )
}

export default withStyles(styles, { withTheme: true })(AdminInstrucAdd)